import React from 'react';
import PropTypes from 'prop-types';

export default function CustomRadio({
  id,
  onChange,
  onClick,
  checked,
  disabled,
  label,
  isCheckbox,
}) {
  return (
    <label className="custom-checkbox-container" htmlFor={`radio-${id}`}>
      <input
        id={`radio-${id}`}
        value={id}
        type={isCheckbox ? 'checkbox' : 'radio'}
        onChange={onChange}
        onClick={onClick}
        checked={checked}
        disabled={disabled}
      />
      <span className="checkmark" />
      {label && <p>{label}</p>}
    </label>
  );
}

CustomRadio.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  isCheckbox: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

CustomRadio.defaultProps = {
  onClick: () => {},
  onChange: () => {},
  disabled: false,
  label: null,
  isCheckbox: false,
};
